




import {Component, Ref, Vue} from 'vue-property-decorator'
import Tariff from '../Tarification/Tariff.vue';
import {TarificationTypes, TarificationTransports} from "@/store/tarification/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {Tariff}})
export default class ViberPartnerTariff extends Vue {

  @Ref('tariff') tariff!: Tariff;

  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private tarificationTransport: TarificationTransports = TarificationTransports.VIBER;

  beforeRouteLeave(to: any, from: any, next: any) {
    this.tariff.beforeLeave(to, from, next);
  }
}
